import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ExerciseIcon } from '../branding/ExerciseIcon';
import { ElementLoading } from '../components/ElementLoading';
import { Title } from '../components/Title';
import { ContentScreen } from '../styles/ContentScreen';
import { assetsUrl, categories } from '../util/constants';

const ExerciseList = ({ title, exercises, linkPrefix }) => (
   <section>
      {title && <h2>{title}</h2>}
      {exercises == null && <ElementLoading />}
      {exercises &&
         (exercises.length > 0 ? (
            exercises.map(
               ({ id, iconId, title: exerciseTitle, description }) => (
                  <Link
                     to={`${linkPrefix}/${id}`}
                     key={id}
                     className="exercise-item"
                  >
                     <h3 className="exercise-item-above-grid-header">
                        {exerciseTitle}
                     </h3>
                     <div className="exercise-item-grid">
                        <div className="exercise-icon">
                           <ExerciseIcon iconId={iconId} />
                        </div>
                        <div>
                           <h3 className="exercise-item-in-grid-header">
                              {exerciseTitle}
                           </h3>
                           <p>{description}</p>
                        </div>
                     </div>
                  </Link>
               )
            )
         ) : (
            <p>Coming Soon</p>
         ))}
   </section>
);

const ExerciseListStyles = styled(ContentScreen)`
   a {
      color: var(--text-color);
      text-decoration: none;
   }

   .exercises-by-category {
      pointer-events: none;
   }

   .exercises-by-category section:first-child {
      margin-bottom: 3em;
   }

   .exercise-item {
      pointer-events: all;
      margin-bottom: 2em;
      margin-bottom: 1.5em;
      display: block;

      h3 {
         margin-bottom: 0.5em;
      }

      h3 {
         font-size: 1.125em;
      }
   }

   @media (min-width: 750px) {
      .exercises-by-category {
         display: grid;
         grid-template-columns: 1fr 1fr;
         grid-gap: 2em;

         h2 {
            max-width: calc((var(--safe-width) - 6rem) / 2);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
         }

         section:first-child {
            margin-bottom: 0;
         }
      }
   }

   .exercise-item-in-grid-header {
      display: none;
   }
   @media (min-width: 350px) {
      .exercise-item {
         h3 {
            font-size: 1.25em;
         }
      }

      .exercise-item-above-grid-header {
         display: none;
      }

      .exercise-item-in-grid-header {
         display: block;
      }
   }

   .exercise-item-grid {
      display: grid;
      grid-template-columns: 4em 1fr;
      grid-gap: 1.5em;
   }

   .exercise-icon {
      display: flex;
      align-items: center;

      svg {
         width: 100%;
      }

      .svg-icon-highlight {
         transition: fill 0.33s ease;
      }
   }

   .exercises-by-category:hover .exercise-item {
      .svg-icon-highlight {
         fill: var(--brand-dark-green);
      }

      :hover {
         .svg-icon-highlight {
            fill: var(--brand-orange);
         }
      }
   }

   @media (prefers-color-scheme: dark) {
      .exercises-by-category:hover .exercise-item {
         .svg-icon-highlight {
            fill: var(--brand-light-green);
         }
      }
   }
`;

const ExerciseListScreen = ({ linkPrefix, title, description }) => {
   const [exercises, setExercises] = useState(null);

   useEffect(() => {
      fetch(`${assetsUrl}/public/exercise/exerciseList.json`)
         .then((res) => res.json())
         .then(setExercises);
   }, []);

   return (
      <ExerciseListStyles>
         <Title title={title} description={description} />
         <h1>Exercises</h1>
         <div className="exercises-by-category">
            <ExerciseList
               title="Music Theory"
               exercises={
                  exercises &&
                  exercises.filter(
                     ({ category }) =>
                        category === categories.theoryAndComposition
                  )
               }
               linkPrefix={linkPrefix}
            />
            <ExerciseList
               title="Mixing & Mastering"
               exercises={
                  exercises &&
                  exercises.filter(
                     ({ category }) =>
                        category === categories.mixingAndMastering
                  )
               }
               linkPrefix={linkPrefix}
            />
         </div>
      </ExerciseListStyles>
   );
};

export { ExerciseListScreen };
